<template>
  <div>
    <v-dialog v-model="dialog" width="1100" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Employee</span>
        </v-card-title>
        <v-card-text>
          <v-tabs v-model="tab">
            <v-tab>Employee Info</v-tab>
            <v-tab>
              Requirements
              <v-chip small class="ml-2" color="primary" dark>{{
                item.items ? item.items.length : 0
              }}</v-chip>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <!-- Tab 1: Employee Info -->
            <v-tab-item>
              <v-row class="mt-2">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                      <v-subheader>Name</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="8" lg="8">
                      <v-text-field
                        outlined
                        flat
                        dense
                        background-color="white"
                        v-model="item.name"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                      <v-subheader>Division</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="8" lg="8">
                      <v-text-field
                        outlined
                        flat
                        dense
                        background-color="white"
                        v-model="item.division"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" v-if="!item.external">
                  <v-row>
                    <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                      <v-subheader>Account Number</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="8" lg="8">
                      <v-text-field
                        outlined
                        flat
                        dense
                        background-color="white"
                        v-model="item.bankAccountNumber"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" v-if="!item.external">
                  <v-row>
                    <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                      <v-subheader>Owner Bank</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="8" lg="8">
                      <v-text-field
                        flat
                        dense
                        outlined
                        background-color="white"
                        v-model="item.ownerBank"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" v-if="!item.external">
                  <v-row>
                    <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                      <v-subheader>External</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="8" lg="8">
                      <v-checkbox
                        flat
                        dense
                        outlined
                        background-color="white"
                        v-model="item.external"
                        @change="onChangeExternal"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" v-if="item.external">
                  <v-row>
                    <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                      <v-subheader>Bank</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="8" lg="8">
                      <v-select
                        dense
                        outlined
                        flat
                        background-color="white"
                        v-model="bank"
                        @change="onChangeBank"
                        return-object
                        item-text="name"
                        :items="banks"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" v-if="item.external">
                  <v-row>
                    <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                      <v-subheader>Account Number</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="8" lg="8">
                      <v-text-field
                        dense
                        outlined
                        flat
                        background-color="white"
                        v-model="item.externalAccountNumber.accountNumber"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" v-if="item.external">
                  <v-row>
                    <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                      <v-subheader>Owner Name</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="8" lg="8">
                      <v-text-field
                        dense
                        outlined
                        flat
                        background-color="white"
                        v-model="item.externalAccountNumber.ownerName"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- WO Section -->
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="12" md="6" lg="4">
                      <v-autocomplete
                        outlined
                        flat
                        dense
                        :items="listWo"
                        item-text="id"
                        background-color="white"
                        v-model="wo"
                        @change="onChangeWo"
                        :filter="filterObjectWo"
                        return-object
                      >
                        <template v-slot:item="data">
                          <v-list-item-content>
                            <v-list-item-title
                              >{{ data.item.id }} (
                              {{ woDate(data.item.tasks) }})</v-list-item-title
                            >
                            <v-list-item-subtitle>{{
                              woSite(data.item.tasks)
                            }}</v-list-item-subtitle>
                            <v-list-item-subtitle>{{ data.item.poNumber }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="8" class="text-right pb-0">
                      <p class="headline font-italic">WO</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headersWo"
                        :items="item.wos"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:item.no="{ index }">
                          {{ index + 1 }}
                        </template>
                        <template v-slot:item.action="{ index }">
                          <v-btn icon @click="deleteWo(index)" color="red">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- Tab 2: Requirements -->
            <v-tab-item>
              <v-row class="mt-2">
                <v-col cols="12" sm="12" md="5" lg="5">
                  <v-autocomplete
                    outlined
                    flat
                    dense
                    background-color="white"
                    append-icon="mdi-magnify"
                    :items="listCategory"
                    item-text="category"
                    return-object
                    v-model="category"
                    @change="onChangeCategory"
                    label="Category"
                  >
                    <template v-slot:item="data">
                      <v-list-item v-on="data.on">
                        <v-list-item-content>
                          <v-list-item-title v-html="data.item.category"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="5" lg="5">
                  <v-autocomplete
                    outlined
                    flat
                    dense
                    background-color="white"
                    append-icon="mdi-magnify"
                    :items="listTemplate"
                    item-text="name"
                    return-object
                    v-model="template"
                    @change="onChangeTemplate"
                    label="Template"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="2" lg="2" align-self="start" class="text-right pb-0">
                  <p class="subtitle-1 font-italic">Requirement <span class="red--text">*</span></p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    :headers="headersItem"
                    :items="item.items"
                    disable-pagination
                    hide-default-footer
                    @click:row="onClickItem"
                    item-key="index"
                  >
                    <template v-slot:item.no="{ index }">
                      {{ index + 1 }}
                    </template>
                    <template v-slot:item.amount="{ item }">
                      {{ formatPrice(item.amount) }}
                    </template>
                    <template v-slot:item.usedAmount="{ item }">
                      {{ formatPrice(item.usedAmount) }}
                    </template>
                    <template v-slot:item.remainAmount="{ item }">
                      {{ formatPrice(item.remainAmount) }}
                    </template>
                    <template v-slot:item.emoney="{ item }">
                      <v-checkbox v-model="item.emoney" dense disabled></v-checkbox>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row justify="end" class="mt-2 mr-1">
                <v-col cols="auto">
                  <v-card outlined>
                    <v-card-title class="py-0 subtitle-1">Total Kasbon</v-card-title>
                    <v-card-text class="text-right mt-1">
                      <span>{{ formatPrice(totalAmount) }}</span>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="auto">
                  <v-card outlined>
                    <v-card-title class="py-0 subtitle-1">Total Used</v-card-title>
                    <v-card-text class="text-right mt-1">
                      <span>{{ formatPrice(totalUseAmount) }}</span>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="auto">
                  <v-card outlined>
                    <v-card-title class="py-0 subtitle-1">Remain Kasbon</v-card-title>
                    <v-card-text class="text-right mt-1">
                      <span>{{ formatPrice(totalRemainAmount) }}</span>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="auto">
                  <v-card outlined>
                    <v-card-title class="py-0 subtitle-1">Total PPH</v-card-title>
                    <v-card-text class="text-right mt-1">
                      <span>{{ formatPrice(pphAmount) }}</span>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close">Close</v-btn>
          <v-btn color="red" @click="deleteItem">Delete</v-btn>
          <v-btn color="primary" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Nested dialog for adding/editing a requirement item -->
    <dialog-kasbon
      :dialog="itemDialog"
      :item="activeItem"
      :index="activeIndex"
      :listCategory="listCategory"
      @close="closeItemDialog"
      @save="saveItem"
      @deleteItem="deleteItemFromList"
      type="other"
    ></dialog-kasbon>
  </div>
</template>

<script>
import DialogKasbon from "@/components/DialogKasbon";
import moment from "moment";

export default {
  name: "dialog-employee-with-settlement-items",
  components: {
    "dialog-kasbon": DialogKasbon,
  },
  props: {
    dialog: Boolean,
    item: Object,
    index: Number,
    banks: Array,
    listWo: Array,
    listCategory: Array,
    listTemplate: Array,
  },
  data() {
    return {
      tab: 0,
      wo: null,
      bank: null,
      category: null,
      template: null,
      itemDialog: false,
      activeItem: {},
      activeIndex: -1,
      headersWo: [
        { text: "No", value: "no", sortable: false, divider: true },
        { text: "WO Number", value: "woId", sortable: false, divider: true },
        { text: "Site", value: "sites", sortable: false, divider: true },
        { text: "Date", value: "dates", sortable: false, divider: true },
        { text: "PO#", value: "poNumber", sortable: false, divider: true },
        { text: "Action", value: "action", sortable: false, divider: true },
      ],
      headersItem: [
        { text: "No", value: "no", sortable: false, divider: true },
        { text: "Requirement", value: "category", sortable: false, divider: true },
        { text: "Description", value: "description", sortable: false, divider: true },
        { text: "Start Date", value: "startDate", sortable: false, divider: true },
        { text: "End Date", value: "endDate", sortable: false, divider: true },
        { text: "Amount", value: "amount", sortable: false, divider: true },
        { text: "Used Amount", value: "usedAmount", sortable: false, divider: true },
        { text: "Remain Amount", value: "remainAmount", sortable: false, divider: true },
        { text: "eMoney", value: "emoney", sortable: false, divider: true },
        { text: "Account Name", value: "accountName", sortable: false, divider: true },
      ],
    };
  },
  computed: {
    totalAmount() {
      if (!this.item || !this.item.items) return 0;
      return this.item.items
        .filter(x => x.calculated)
        .map(x => x.amount)
        .reduce((a, b) => a + b, 0);
    },
    totalUseAmount() {
      if (!this.item || !this.item.items) return 0;
      return this.item.items
        .filter(x => x.calculated)
        .map(x => x.usedAmount)
        .reduce((a, b) => a + b, 0);
    },
    totalRemainAmount() {
      if (!this.item || !this.item.items) return 0;
      return this.item.items
        .filter(x => x.calculated)
        .map(x => x.remainAmount)
        .reduce((a, b) => a + b, 0);
    },
    pphAmount() {
      if (!this.item || !this.item.items) return 0;
      return this.item.items
        .filter(x => !x.calculated)
        .map(x => x.amount)
        .reduce((a, b) => a + b, 0);
    },
  },
  methods: {
    save() {
      this.$emit("save", this.item);
      this.$emit("close");
    },
    close() {
      this.tab = 0;
      this.$emit("close");
    },
    deleteItem() {
      this.$emit("deleteItem", this.index);
    },
    onChangeExternal(val) {
      if (val) {
        this.item.externalAccountNumber = {
          bankName: "",
          ownerBank: "",
          accountNumber: "",
          swiftCode: "",
        };
      } else {
        this.item.externalAccountNumber = null;
        this.bank = null;
      }
    },
    onChangeBank(val) {
      this.item.externalAccountNumber.bankName = val.name;
      this.item.externalAccountNumber.swiftCode = val.swiftCode;
    },
    onChangeWo(val) {
      if (this.item.wos.findIndex(x => x.woId === val.id) > -1) {
        this.$store.dispatch("toast", { type: "error", message: "WO sudah digunakan" });
      } else {
        this.item.wos.push({
          woId: val.id,
          sites: this.woSite(val.tasks),
          dates: this.woDate(val.tasks),
          poNumber: val.poNumber,
        });
      }
    },
    deleteWo(index) {
      this.item.wos.splice(index, 1);
    },
    woSite(tasks) {
      if (tasks && tasks.length > 0) {
        let siteName = [];
        tasks.map(x => {
          if (x.trips && x.trips.length > 0) {
            return x.trips.forEach(y => siteName.push(y.siteName));
          }
        });
        return siteName.filter((v, i, s) => s.indexOf(v) === i).join(",");
      }
      return "";
    },
    woDate(tasks) {
      if (tasks && tasks.length > 0) {
        return tasks
          .map(x => x.date)
          .filter((v, i, s) => s.indexOf(v) === i)
          .join(",");
      }
      return "";
    },
    // eslint-disable-next-line no-unused-vars
    filterObjectWo(item, queryText, itemText) {
      return (
        item.id.toString().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        this.woSite(item.tasks)
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        this.woDate(item.tasks)
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        (item.poNumber &&
          item.poNumber.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1)
      );
    },
    onChangeCategory(val) {
      this.activeItem = {
        requirementCategoryId: val.requirementCategoryId,
        category: val.category,
        description: val.description,
        accountName: val.accountName,
        amount: 0,
        usedAmount: 0,
        remainAmount: 0,
        startDate: moment().format("yyyy-MM-DD"),
        endDate: moment().format("yyyy-MM-DD"),
        emoney: false,
        calculated: val.calculated !== undefined ? val.calculated : true,
      };
      this.activeIndex = -1;
      this.itemDialog = true;
    },
    onChangeTemplate(val) {
      if (val && val.items) {
        val.items.forEach(x =>
          this.item.items.push({
            ...x,
            usedAmount: x.usedAmount || 0,
            remainAmount: x.remainAmount || 0,
          })
        );
      }
      this.template = null;
    },
    onClickItem(row) {
      this.activeItem = { ...row };
      this.activeIndex = this.item.items.indexOf(row);
      this.itemDialog = true;
    },
    saveItem(savedItem) {
      if (this.activeIndex > -1) {
        this.item.items.splice(this.activeIndex, 1, savedItem);
      } else {
        this.item.items.push({ ...savedItem });
      }
      this.category = null;
    },
    deleteItemFromList(idx) {
      if (idx > -1) {
        this.item.items.splice(idx, 1);
      }
      this.itemDialog = false;
      this.category = null;
    },
    closeItemDialog() {
      this.itemDialog = false;
      this.category = null;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>

<style></style>
